import { atom } from "recoil"

export const templatesRequestIdState = atom({
  key: "atoms/contact/templatesRequestIdState",
  default: 0,
})
